<div class="row">
  <div class="col-12">
    <h1>Colors</h1>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Red (500 == Primary)</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [100, 200, 400, 500, 600]"
        [ngClass]="['sh-red-' + q + '-bg']">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Grey</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [150, 150, 200, 300, 400, 450, 500, 600, 700, 800]"
        [ngClass]="['sh-grey-' + q + '-bg']">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Blue</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [100, 500]"
        [ngClass]="['sh-blue-' + q + '-bg']">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Green</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [500]"
        [ngClass]="['sh-green-' + q + '-bg']">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Warn</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [500]"
        [ngClass]="['sh-warn-' + q + '-bg']">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Activity types</h2>
    <ul class="m-0 p-0">
      <li class="p-3 -activity-type-strategy">Strategy &amp; Management</li>
      <li class="p-3 -activity-type-supply">Supply Chain</li>
      <li class="p-3 -activity-type-climate">Climate, Environment &amp; Energy</li>
      <li class="p-3 -activity-type-employees">Employees</li>
      <li class="p-3 -activity-type-human">Human Rights</li>
      <li class="p-3 -activity-type-community">Community</li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>SDGs</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]"
        [ngClass]="['sdg-' + q]">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Logo colors (light)</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [1, 2, 3, 4, 5, 6, 7, 8]"
        [ngClass]="['logo-light-' + q]">
        {{ q }}
      </li>
    </ul>
  </div>

  <div class="col-12 mb-5 col-sm-6 col-md 4 col-lg-3">
    <h2>Logo colors (dark)</h2>
    <ul class="m-0 p-0">
      <li
        class="p-3"
        *ngFor="let q of [1, 2, 3, 4, 5, 6, 7, 8]"
        [ngClass]="['logo-dark-' + q]">
        {{ q }}
      </li>
    </ul>
  </div>
</div>
